import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import * as React from 'react';
import styled from 'styled-components';
import { Stars } from '@ifixit/toolbox';
import { color } from '@core-ds/primitives';
var StarsContainer = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   min-width: 115px;\n   padding-right: 8px;\n"])));
var Timestamp = styled.h4(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n   margin: 0;\n   font-size: 12px;\n   font-weight: bold;\n   line-height: 1.25;\n"])));
var Headline = styled.h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n   margin: 8px 0 0;\n   font-size: 18px;\n   font-weight: bold;\n   line-height: 27px;\n"])));
var ProductVariantName = styled.h3(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n   margin: 0;\n   font-size: 15px;\n   font-weight: bold;\n   line-height: 27px;\n"])));

var Header = function Header(_ref) {
  var rating = _ref.rating,
      headline = _ref.headline,
      date = _ref.date,
      productName = _ref.productName,
      productVariantName = _ref.productVariantName;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Headline, null, /*#__PURE__*/React.createElement(StarsContainer, null, /*#__PURE__*/React.createElement(Stars, {
    rating: rating,
    size: 23,
    activeColor: color.blue[600]
  })), headline), productName && productVariantName && /*#__PURE__*/React.createElement(ProductVariantName, null, productName, " | ", productVariantName), /*#__PURE__*/React.createElement(Timestamp, null, date));
};

export default Header;